module.exports = __webpack_public_path__ + "static/media/ch.30527cb5.png";